/**
 * Pure counter math for shard-safe number allocation.
 *
 * Firebase runs the transaction updater more than once: first with a local
 * cache (often null), then again with the server value if that guess lost.
 * Returning a number — never undefined — lets the SDK retry instead of
 * aborting. The value stored is base + 1. Callers that stamp a record number
 * use the pre-increment value (committed - 1), which is what the forms used
 * to copy out of the Vuex cache before a separate increment.
 */

export function nextCounterValue(current) {
  const parsed = parseInt(current, 10);
  const base = Number.isFinite(parsed) ? parsed : 0;
  return base + 1;
}

export function claimedCounterValue(committed) {
  const parsed = parseInt(committed, 10);
  if (!Number.isFinite(parsed) || parsed < 1) {
    throw new Error("Counter did not commit a usable number");
  }
  return parsed - 1;
}
